import { Card, Header } from 'semantic-ui-react'
import { observer } from 'mobx-react-lite';
import { Rider } from '../../../app/models/permit';

interface Props {
    rider: Rider
}

export default observer(function RiderCardContent({ rider }: Props) {
    return (
        <>
        <Card.Content>
            <Card.Header>{`${rider.firstName} ${rider.lastName}`}</Card.Header>
            <Card.Meta style={{fontSize: '1.2em'}}>
                {rider.phone}
            </Card.Meta>
            <Card.Description>
                {rider.address}<br />
                {rider.address2}<br />
                {`${rider.city}, WA ${rider.zipcode}`}
            </Card.Description>
        </Card.Content>
        <Card.Content>
            <Header content='Work Destination' sub color='teal' />
            <Card.Description>
                {rider.employerName} <br />
                {`${rider.employerCity}, WA ${rider.employerZipcode}`}
            </Card.Description>
        </Card.Content>
        </>
    )
})